

const Terms = () => {
  return (
    <div className="terms">
      <div className="terms__container">
        <h1 className="terms__title">Terms and Conditions</h1>

        <section className="terms__section">
          <h2>1. Introduction</h2>
          <p>
            Welcome to Ozjackpotclaim. These Terms and Conditions govern your use of our website,
            and the services provided by us. By accessing or using our website, you agree to comply
            with these terms. If you do not agree with these terms, please do not use our services.
          </p>
          <p>Email: <a href="mailto:info@Ozjackpotclaim.com">info@Ozjackpotclaim.com</a></p>
        </section>

        <section className="terms__section">
          <h2>2. Eligibility</h2>
          <p>
            To use our services, you must be at least 18 years old and legally capable of entering
            into contracts. By using our services, you confirm that you meet these eligibility requirements.
          </p>
        </section>

        <section className="terms__section">
          <h2>3. Use of Our Services</h2>
          <p>You agree to use our services only for lawful purposes and in accordance with these Terms. You will not:</p>
          <ul>
            <li>Use the services in any way that violates any applicable laws or regulations.</li>
            <li>Engage in any conduct that restricts or inhibits anyone’s use or enjoyment of the services.</li>
            <li>Transmit any advertisements or promotional materials without our prior written consent.</li>
          </ul>
        </section>

        <section className="terms__section">
          <h2>4. Account Creation</h2>
          <p>
            To access certain features of our services, you may need to create an account. You agree
            to provide accurate, current, and complete information during the registration process
            and to update such information to keep it accurate, current, and complete. You are
            responsible for safeguarding your password and other account credentials and for all
            activities that occur under your account.
          </p>
        </section>

        <section className="terms__section">
          <h2>5. Intellectual Property</h2>
          <p>
            All content, trademarks, and other intellectual property rights on our website are owned
            by or licensed to Ozjackpotclaim. You are granted a limited license to access and use
            the website for personal, non-commercial purposes only. Any other use, including the
            reproduction, modification, distribution, or republication of the website’s content, is
            strictly prohibited.
          </p>
        </section>

        <section className="terms__section">
          <h2>6. Third-Party Links</h2>
          <p>
            Our website may contain links to third-party websites that are not controlled or operated
            by us. We are not responsible for the content, privacy policies, or practices of these
            third-party sites. Your use of such sites is at your own risk.
          </p>
        </section>

        <section className="terms__section">
          <h2>7. Disclaimer of Warranties</h2>
          <p>
            Our services are provided on an “as is” and “as available” basis without any warranties
            of any kind, either express or implied. We do not warrant that the services will be
            uninterrupted, secure, or free of errors or viruses.
          </p>
        </section>

        <section className="terms__section">
          <h2>8. Limitation of Liability</h2>
          <p>
            To the fullest extent permitted by law, Ozjackpotclaim shall not be liable for any
            indirect, incidental, special, consequential, or punitive damages, including without
            limitation loss of profits, data, use, goodwill, or other intangible losses, resulting
            from your use of or inability to use our services.
          </p>
        </section>

        <section className="terms__section">
          <h2>9. Indemnification</h2>
          <p>
            You agree to indemnify, defend, and hold harmless Ozjackpotclaim and its affiliates,
            officers, directors, employees, and agents from any claims, damages, losses, liabilities,
            costs, or expenses (including reasonable attorneys’ fees) arising out of or related to
            your use of our services, violation of these Terms, or infringement of any rights of
            another party.
          </p>
        </section>

        <section className="terms__section">
          <h2>10. Governing Law</h2>
          <p>
            These Terms and Conditions shall be governed by and construed in accordance with the laws
            of Your Jurisdiction, without regard to its conflict of law principles. Any legal action
            or proceeding arising out of or related to these Terms shall be brought exclusively in
            the courts located in Your Jurisdiction.
          </p>
        </section>

        <section className="terms__section">
          <h2>11. Changes to These Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. We will notify you of any changes
            by posting the new Terms on this page and updating the “Effective Date” at the top. Your
            continued use of the services after any changes constitutes your acceptance of the new Terms.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Terms;
